import { render, staticRenderFns } from "./AjaxResetPassword.vue?vue&type=template&id=bb34e8b4"
import script from "./AjaxResetPassword.vue?vue&type=script&lang=js"
export * from "./AjaxResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports